<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['chartData', 'options'],
  methods: {
    update() {
      this.$data._chart.update()
    }
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart(this.chartData, this.options)
      }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
